import {REMOTE_SENSING_PRODUCTS} from '../Images/remoteSensingModel'

const IMAGE_LAYERS = new Set(['rgb', 'evi', 'ndvi', 'ndre'])
const PRODUCTS = new Set(Object.values(REMOTE_SENSING_PRODUCTS))

export const getComparisonLayerSelectValue = (product, layerType) =>
  IMAGE_LAYERS.has(layerType) ? `${product}:${layerType}` : layerType

export const parseComparisonLayerSelectValue = (value) => {
  const [product, layerType, extra] = String(value || '').split(':')

  if (!extra && PRODUCTS.has(product) && IMAGE_LAYERS.has(layerType)) {
    return {product, layerType}
  }

  return {product: null, layerType: value}
}
